// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,

    apiBaseUrl: 'https://test.api-v1.e-vend.com.tr/v1/',
    localBaseUrl: 'http://localhost:5001/v1/',
    localPaymentBaseUrl: 'http://localhost:10010/v1/',
    SOCKET_URL: 'https://test.api-v1.e-vend.com.tr/',
    ProfileImagePath: 'https://test.api-v1.e-vend.com.tr/img/profiles/',
    StaffImagePath: 'https://test.api-v1.e-vend.com.tr/img/staffs/',
    AutomatImagePath: 'https://test.api-v1.e-vend.com.tr/img/automats/',
    ProductImagePath: 'https://test.api-v1.e-vend.com.tr/img/products/',

    /* apiBaseUrl: 'http://192.168.1.41:8080/v1/',
    SOCKET_URL: 'http://192.168.1.41:3001/',
    ProfileImagePath: 'http://192.168.1.41/profiles/',
    StaffImagePath: 'http://192.168.1.41/staffs/',
    AutomatImagePath: 'http://192.168.1.41/automats/',
    ProductImagePath: 'http://192.168.1.41/products/', */
  
    /* apiBaseUrl: 'http://192.168.1.39:10100/v1/',
    SOCKET_URL: 'http://192.168.1.39:3001/',
    ProfileImagePath: 'http://192.168.1.39:10100/img/profiles/',
    StaffImagePath: 'http://192.168.1.39:10100/img/staffs/',
    AutomatImagePath: 'http://192.168.1.39:10100/img/automats/',
    ProductImagePath: 'http://192.168.1.39:10100/img/products/', */
};



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/environments/environment.ts